import { ReactNode } from 'react';
import classNames from 'classnames';

import { ListContainer } from '~/components/atoms/ListContainer';

import styles from './MenuOptionsGroup.module.scss';

type TSettingsGroupProps = {
  label: string;
  className?: string;
  children?: ReactNode | undefined;
};

export function MenuOptionsGroup({
  label,
  children,
  className,
}: TSettingsGroupProps): JSX.Element {
  return (
    <section>
      <h5 className={styles.label}>{label}</h5>
      <ListContainer className={classNames(styles.options, className)}>
        {children}
      </ListContainer>
    </section>
  );
}
